import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { ActionButton } from './ActionButton';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export function Modal({ open, onClose, title, children, footer }: ModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative z-10 w-full max-w-lg rounded-2xl border border-dark-border bg-dark-surface shadow-2xl">
        <div className="flex items-center justify-between gap-2 border-b border-dark-border px-4 py-3 sm:px-5 sm:py-4">
          <h3 className="min-w-0 truncate text-base font-semibold text-gray-100 sm:text-lg">{title}</h3>
          <button
            onClick={onClose}
            className="shrink-0 rounded-lg p-1 text-gray-400 hover:bg-dark-border hover:text-gray-200"
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>
        <div className="max-h-[70vh] overflow-y-auto p-4 sm:p-5">{children}</div>
        {footer && (
          <div className="flex flex-wrap justify-end gap-2 border-t border-dark-border px-4 py-3 sm:px-5 sm:py-4">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}

export function ModalActions({
  onCancel,
  onConfirm,
  confirmLabel = 'Salvar',
  loading,
}: {
  onCancel: () => void;
  onConfirm: () => void;
  confirmLabel?: string;
  loading?: boolean;
}) {
  return (
    <>
      <ActionButton variant="secondary" onClick={onCancel}>
        Cancelar
      </ActionButton>
      <ActionButton onClick={onConfirm} loading={loading}>
        {confirmLabel}
      </ActionButton>
    </>
  );
}
